// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-list {
  padding: var(--spacing-sm);
}

.contact-section {
  margin-bottom: var(--spacing-md);
}

.contact-section-title {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wider);
  color: var(--text-tertiary);
  padding: var(--spacing-xs) var(--spacing-sm);
  margin-bottom: var(--spacing-xs);
}

.contact-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-sm);
  border-radius: var(--radius-md);
  transition: background var(--transition-fast);
}

.contact-item-online {
  cursor: pointer;
}

.contact-item-online:hover {
  background: var(--bg-hover);
}

.contact-item-offline {
  opacity: 0.45;
  cursor: pointer;
}

.contact-item-offline:hover {
  background: var(--bg-hover);
}

.contact-item-selected {
  background: var(--bg-hover);
  border-left: 2px solid var(--color-primary);
}

.contact-item-offline.contact-item-selected {
  opacity: 0.7;
}

.contact-avatar {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

.contact-status {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-radius: var(--radius-full);
  border: 2px solid var(--bg-elevated);
}

.contact-status.online {
  background: var(--color-success);
  box-shadow: 0 0 6px var(--color-success-glow);
}

.contact-status.offline {
  background: var(--text-tertiary);
}

.contact-info {
  flex: 1;
  min-width: 0;
}

.contact-name {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.contact-type {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-normal);
  color: var(--text-tertiary);
}

.contact-badge-builtin {
  display: inline-block;
  font-size: 10px;
  font-weight: var(--font-weight-medium);
  color: var(--color-primary);
  background: var(--color-primary-glow);
  padding: 0 6px;
  border-radius: var(--radius-full);
  margin-left: 6px;
  vertical-align: middle;
}

.contact-desc {
  font-size: var(--font-size-xs);
  color: var(--text-tertiary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contact-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-3xl) var(--spacing-lg);
  text-align: center;
}

.contact-empty-text {
  margin: var(--spacing-md) 0 var(--spacing-xs) 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.contact-empty-hint {
  margin: 0;
  font-size: var(--font-size-xs);
  color: var(--text-tertiary);
}

.new-bot-btn {
  display: block;
  width: calc(100% - var(--spacing-md) * 2);
  margin: var(--spacing-sm) var(--spacing-md);
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--glass-bg);
  border: 1px dashed var(--glass-border);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  text-align: center;
}

.new-bot-btn:hover {
  background: var(--bg-hover);
  border-color: var(--color-primary);
  color: var(--color-primary);
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/ContactList.css"],"names":[],"mappings":"AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;EAC3B,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,2BAA2B;EAC3B,qCAAqC;EACrC,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;EAC5C,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;AAC7B","sourcesContent":["@import \"../styles/variables.css\";\n\n.contact-list {\n  padding: var(--spacing-sm);\n}\n\n.contact-section {\n  margin-bottom: var(--spacing-md);\n}\n\n.contact-section-title {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  text-transform: uppercase;\n  letter-spacing: var(--letter-spacing-wider);\n  color: var(--text-tertiary);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  margin-bottom: var(--spacing-xs);\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: var(--spacing-sm);\n  border-radius: var(--radius-md);\n  transition: background var(--transition-fast);\n}\n\n.contact-item-online {\n  cursor: pointer;\n}\n\n.contact-item-online:hover {\n  background: var(--bg-hover);\n}\n\n.contact-item-offline {\n  opacity: 0.45;\n  cursor: pointer;\n}\n\n.contact-item-offline:hover {\n  background: var(--bg-hover);\n}\n\n.contact-item-selected {\n  background: var(--bg-hover);\n  border-left: 2px solid var(--color-primary);\n}\n\n.contact-item-offline.contact-item-selected {\n  opacity: 0.7;\n}\n\n.contact-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.contact-status {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  border-radius: var(--radius-full);\n  border: 2px solid var(--bg-elevated);\n}\n\n.contact-status.online {\n  background: var(--color-success);\n  box-shadow: 0 0 6px var(--color-success-glow);\n}\n\n.contact-status.offline {\n  background: var(--text-tertiary);\n}\n\n.contact-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.contact-name {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n}\n\n.contact-type {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-normal);\n  color: var(--text-tertiary);\n}\n\n.contact-badge-builtin {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: var(--font-weight-medium);\n  color: var(--color-primary);\n  background: var(--color-primary-glow);\n  padding: 0 6px;\n  border-radius: var(--radius-full);\n  margin-left: 6px;\n  vertical-align: middle;\n}\n\n.contact-desc {\n  font-size: var(--font-size-xs);\n  color: var(--text-tertiary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.contact-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-3xl) var(--spacing-lg);\n  text-align: center;\n}\n\n.contact-empty-text {\n  margin: var(--spacing-md) 0 var(--spacing-xs) 0;\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n}\n\n.contact-empty-hint {\n  margin: 0;\n  font-size: var(--font-size-xs);\n  color: var(--text-tertiary);\n}\n\n.new-bot-btn {\n  display: block;\n  width: calc(100% - var(--spacing-md) * 2);\n  margin: var(--spacing-sm) var(--spacing-md);\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--glass-bg);\n  border: 1px dashed var(--glass-border);\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  text-align: center;\n}\n\n.new-bot-btn:hover {\n  background: var(--bg-hover);\n  border-color: var(--color-primary);\n  color: var(--color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
